<div style="background-color: #fff; padding: 20px;">
  <h1 mat-dialog-title style="color:#000;">{{ 'Add a product' | translate }}</h1>

  <div mat-dialog-content>
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <form [formGroup]="productForm" (ngSubmit)="onSubmit()">

      <!-- AI Content -->
      <div class="form-group" style="text-align:left; padding: 25px; background-color: #ececec; border: solid 1px #666;">
        <label for="descriptionia" style="color:#000;">{{ 'Artificial intelligence' | translate }}*</label>
        <textarea id="descriptionia" class="form-control" rows="3" formControlName="descriptionia"
                  placeholder="{{ 'Ask AI to generate the content' | translate }}"></textarea>

        <button mat-raised-button color="warning" type="button" style="margin-top: 10px;" (click)="generateTextIa()">
          {{ 'Generate with AI' | translate }}
        </button>
      </div>

      <!-- Title -->
      <div class="form-group">
        <label for="title">{{ 'Title' | translate }}*</label>
        <input id="title" type="text" class="form-control" formControlName="title"
               placeholder="{{ 'Title' | translate }}" />
      </div>

      <!-- Price -->
      <div class="form-group">
        <label for="price">{{ 'Price' | translate }}</label>
        <input id="price" type="text" class="form-control" formControlName="price"
               placeholder="{{ 'Price' | translate }}" />
      </div>

      <!-- Description -->
      <div class="form-group" style="text-align:left;">
        <label for="description">{{ 'Description' | translate }}*</label>
        <textarea id="description" class="form-control" rows="5" formControlName="description"
                  placeholder="{{ 'Description' | translate }}"></textarea>
      </div>

      <!-- Image -->
      <div class="form-group">
        <label for="image">{{ 'Image' | translate }}</label>
        <input id="image" type="file" class="form-control" formControlName="image" (change)="onFileChange($event)" />
      </div>

      <!-- Allergens -->
      <div formArrayName="allergens">
        <div *ngFor="let allergen of allergenos; let i = index">
          <label class="allergen-label">
            <input type="checkbox" [formControlName]="i">
            <img [src]="allergen.iconUrl" mat-icon-button matTooltip="{{ allergen.name }}" class="round-icon" width="50" />
            {{ allergen.name }}
          </label>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer buttons -->
  <div mat-dialog-actions style="justify-content: flex-end; padding-right:20px; margin-bottom:0;">
    <button mat-raised-button color="secondary" type="button"
            *ngIf="productForm.get('id')?.value"
            (click)="deleteProduct()">
      {{ 'Delete' | translate }}
    </button>

    <button mat-raised-button color="primary" type="button"
            [disabled]="productForm.invalid"
            (click)="onSubmit()">
      {{ 'Update' | translate }}
    </button>
  </div>
</div>
